<form (ngSubmit)="add()" [formGroup]="form">
    <div style="width: 500px">
        <div class="title">Add server license</div>

        <app-alert/>

        <div class="label">Duration (Days)</div>
        <input autofocus class="field" formControlName="duration" required type="number">

        <button [disabled]="!form.valid || isLoading" class="button" type="submit">
            <span [hidden]="isLoading">Submit</span>
            <img [hidden]="!isLoading" alt="Loading" src="../../../../assets/img/spinner.svg"/>
        </button>
    </div>
</form>